import { ImageWithHoverZoom } from "./ImageWithHoverZoom";
import type { OptionsType } from "./types";
import { getUrlProtocol } from "./url";

export function formatImage(
  value: string,
  { jsx, rich, view_as = "auto", isDashboard }: OptionsType = {},
) {
  const url = String(value);
  const protocol = getUrlProtocol(url);
  const acceptedProtocol = protocol === "http:" || protocol === "https:";
  if (jsx && rich && view_as === "image" && acceptedProtocol) {
    return (
      <ImageWithHoverZoom src={url} height={30} isDashboard={isDashboard} />
    );
  } else {
    return url;
  }
}
